import { Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IJsonLdData } from '@shared/shared-meta/page-meta.service';

@Component({
  standalone: false,
  selector: 'ui-json-ld',
  template: '',
})
export class UiJsonLdComponent implements OnChanges {
  @Input() jsons: IJsonLdData[];
  @HostBinding('innerHTML') jsonLD: SafeHtml;

  constructor(private sanitizer: DomSanitizer) {
  }

  public ngOnChanges(changes: SimpleChanges) {
    this.jsonLD = this.getSafeHTML(changes.jsons.currentValue);
  }

  public getSafeHTML(jsons: IJsonLdData[]) {
    if (!jsons || !jsons.length) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }

    const html = jsons
      .filter((v) => Boolean(v.json))
      .map((v) => {
        const schema = {
          '@context': 'http://schema.org/',
        };

        const strJson = JSON.stringify({ ...schema, ...v.json }, null, 2)
          .replace(/<\/script>/g, '<\\/script>');
        return `<script type="application/ld+json">${strJson}</script>`;
      })
      .join('\n');

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
